module.exports = __webpack_public_path__ + "img/account-vineyard_gold.f61438fb.svg";